module.exports = __webpack_public_path__ + "static/img/game1.88da8581.png";